import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

const AccountListRow = ({account}) => {
  return (
    <tr className="gst-row">
      <td className="gst-cell hideMob">
        <Link to={"/account/view/"+ account.id}>{account.id}</Link>
      </td>
      <td className="gst-cell">{account.accountName}</td>
      <td className="gst-cell hideMob">{account.email}</td>
      <td className="gst-cell hideMob">{account.address}</td>
      <td className="gst-cell hideMob">{account.adminName}</td>
      <td className="gst-cell hideMob">{account.mobileNumber}</td>
      <td className="gst-cell">
        <Link to={"/account/edit/"+ account.id}>
          <i className="fa fa-pencil" aria-hidden="true"></i>
        </Link>
      </td>
    </tr>
  );
};

AccountListRow.propTypes = {
    account: PropTypes.object.isRequired
};

export default AccountListRow;



// WEBPACK FOOTER //
// ./src/components/account/AccountListRow.js